module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("A big thank you to everyone who purchased "), _c('em', [_vm._v("Book 1")]), _vm._v(". I am truly grateful for the positive feedback that I have received.")]), _vm._v(" "), _c('p', [_vm._v("Many thanks to all at Austin Macauley Publishers for all their hard work in getting my book, ‘Out the door.’")]), _vm._v(" "), _c('p', [_vm._v("Thank you to everyone for the positive comments and the encouragement to"), _c('br'), _vm._v("\nkeep going.")]), _vm._v(" "), _c('p', [_vm._v("And last, but not least, a huge thank you in advance to everyone who purchases "), _c('em', [_vm._v("Book 2")]), _vm._v("; I hope you enjoy it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee3483c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0